import React from 'react';
import Icon from './Icon';

export default function ResourceCard({ resource }) {
  const ext = resource.ext || 'PDF';
  const hasUrl = Boolean(resource.url);

  return (
    <div className="portal-resource-card">
      <div className={`portal-resource-badge ext-${ext}`}>{ext}</div>
      <div className="portal-resource-meta">
        <div className="portal-resource-title">{resource.title}</div>
        {resource.desc && <div className="portal-resource-desc">{resource.desc}</div>}
        <div className="portal-resource-sub">{ext}{resource.size ? ` · ${resource.size}` : ''}</div>
      </div>
      {hasUrl ? (
        <a
          className="portal-resource-dl"
          href={resource.url}
          target="_blank"
          rel="noreferrer"
          aria-label={`Download ${resource.title}`}
        >
          <Icon name="download" size={18} />
        </a>
      ) : (
        <button
          type="button"
          className="portal-resource-dl"
          aria-label={`Download ${resource.title}`}
          data-resource-title={resource.title}
        >
          <Icon name="download" size={18} />
        </button>
      )}
    </div>
  );
}
